module.exports = __webpack_public_path__ + "avatar_man.png?3e97e55a8fe30bc4fe07954306fc80ad";


//////////////////
// WEBPACK FOOTER
// ./assets/images/avatar_man.png
// module id = 998
// module chunks = 0